/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Source_BothInputs */



/**
* | output |
* | --- |
* | "Outlook + Google" |
*
* @param {Agenda_Source_BothInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_source_both = /** @type {((inputs?: Agenda_Source_BothInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Source_BothInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Outlook + Google")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Outlook + Google")
	return /** @type {LocalizedString} */ ("Outlook + Google")
});